import app from 'flarum/forum/app';
import { api } from '../../common/utils/api';
import { apiPreload } from '../../common/utils/preload';
/**
 * Store local da wishlist do comprador. Carrega os product_ids uma vez (lazy,
 * no primeiro botão que monta) e mantém em memória. Toggle é otimista, com
 * reversão em erro. Compartilhado por todos os botões de coração da página.
 */
class WishlistStore {
  ids = null;
  loading = false;
  isLoaded() {
    return this.ids !== null;
  }
  has(id) {
    return this.ids?.has(Number(id)) ?? false;
  }
  ensureLoaded() {
    if (this.ids !== null || this.loading || !app.session.user) return;
    this.loading = true;
    apiPreload('wishlist', '/marketplace/my/wishlist').then(res => {
      this.ids = new Set((res?.data ?? []).map(d => Number(d.id)));
    }).catch(() => {
      this.ids = new Set();
    }).then(() => {
      this.loading = false;
      m.redraw();
    });
  }
  async toggle(id) {
    const pid = Number(id);
    if (this.ids === null) this.ids = new Set();
    const currently = this.ids.has(pid);
    if (currently) this.ids.delete(pid);else this.ids.add(pid);
    m.redraw();
    try {
      if (currently) {
        await api('DELETE', '/marketplace/my/wishlist/' + pid);
      } else {
        await api('POST', '/marketplace/my/wishlist', {
          product_id: pid
        });
      }
      return !currently;
    } catch (e) {
      if (currently) this.ids.add(pid);else this.ids.delete(pid);
      m.redraw();
      throw e;
    }
  }

  /**
   * Remove SEMPRE (DELETE), independente do que o store conhece. Usado pela
   * página da wishlist, que lista itens direto da API sem popular o store —
   * onde um toggle poderia acabar re-adicionando. Reverte o set em erro.
   */
  async remove(id) {
    const pid = Number(id);
    const had = this.ids?.has(pid) ?? false;
    this.ids?.delete(pid);
    m.redraw();
    try {
      await api('DELETE', '/marketplace/my/wishlist/' + pid);
    } catch (e) {
      if (had) this.ids?.add(pid);
      m.redraw();
      throw e;
    }
  }
  reset() {
    this.ids = null;
  }
}
export const wishlistStore = new WishlistStore();
flarum.reg.add('ramon-marketplace', 'forum/utils/wishlist', { wishlistStore: wishlistStore, });